export async function getLiveExchangeRate(currency: string): Promise<number | null> {
  currency = currency.toUpperCase();

  if (currency === "USD") return 1;

  try {
    const response = await fetch(`https://api.exchangerate-api.com/v4/latest/${currency}`);
    const data = await response.json();
    return data?.rates?.USD ?? null;
  } catch (error) {
    console.error("Error fetching live exchange rate:", error);
    return null;
  }
}
